/* global calculationUrl */
let refreshTimeOut;

export function sidebarScroll() {
    const tmpWindow = $(window);
    const tmpSWrapper = $('#serviceWrapper');
    let calcOffsetBottom;
    const sideCalculation = $('#sideCalculation');
    const calcOffsetTop = sideCalculation.offset().top - 20;

    tmpWindow.scroll(() => {
        calcOffsetBottom = tmpSWrapper.height() - sideCalculation.height();

        if (tmpWindow.scrollTop() < calcOffsetTop) {
            sideCalculation.removeClass('fixedCalculation bottomCalculation');
        } else if (tmpWindow.scrollTop() > calcOffsetBottom) {
            sideCalculation.removeClass('fixedCalculation').addClass('bottomCalculation');
        } else {
            sideCalculation.removeClass('bottomCalculation').addClass('fixedCalculation');
        }
    });
}

export function guestTypeChange() {
    const guestType = $('#ReservationCharterSingleForm_g_type').val();

    $('.returningGuestRow, .recommendingRow, .recommendingCodeRow').hide();

    if (guestType === 'popusti_starigost') {
        $('.returningGuestRow').show();
    } else if (guestType === 'recomm') {
        $('.recommendingRow').show();
    } else if (guestType === 'recomm_camp') {
        $('.recommendingCodeRow').show();
    }
}

export function bindChange() {
    $(document).on('change', 'input[id$="_od"], input[id$="_do"], select[id$="_brojosoba"], input[id*="_services_"], '
        + 'select[id$="_g_type"], select[id$="_popusti_starigost_brojusluga"], '
        + 'input[id$="_popusti_starigost_usluge"], input[id$="_recomm_g"], input[id$="user_register_email"]', preCheck);
}

export function preCheck() {
    if (refreshTimeOut) {
        clearTimeout(refreshTimeOut);
    }
    refreshTimeOut = setTimeout(checkPrice, 500);
}

function checkPrice() {
    $('.reservationLoader').show();
    $.post(calculationUrl, $('.reservationForm').serialize(), (response) => {
        $('#olgGuestServicesLabel').hide();
        $('#guestTypeLabel').show();
        const submitButton = document.getElementById('submitReservationForm');

        if (response.status === 'error') {
            submitButton.disabled = true;
            submitButton.classList.add('gray');
            renderErrorMessages(response.data);
        }

        if (response.status === 'success') {
            submitButton.disabled = false;
            submitButton.classList.remove('gray');
            $('#totalPrice').html(response.data.total);
            $('#calculationTableContainer').html(response.data.details);
            $('.calculationDetails').show();
            $('.calculationMessages').html('');
            if (response.data.old_guest.count !== '' && response.data.old_guest.isOldGuest) {
                $('#ReservationCharterSingleForm_g_type').val('popusti_starigost').hide();
                $('#olgGuestServicesLabel').show();
                $('#guestTypeLabel').hide();
                $('#ReservationCharterSingleForm_popusti_starigost_brojusluga').val(response.data.old_guest.count);
                $('#ReservationCharterSingleForm_popusti_starigost_usluge').val(response.data.old_guest.services);
                guestTypeChange();
            }
        }

        if (response.userData.hasConsent) {
            $('#consent').hide();
        } else if ($('#consent').is(':hidden')) {
            $('#consent').show();
        }

        if (response.userData.isUserSubscribedToNewsletter) {
            $('#newsletter').hide();
        } else if ($('#newsletter').is(':hidden')) {
            $('#newsletter').show();
        }

        $('.reservationLoader').hide();
    });
}

function renderErrorMessages(response, errorList) {
    let first = false;
    let errorMessages = errorList;
    if (errorList === undefined) {
        errorMessages = $('<ul />');
        first = true;
    }

    $.each(response, (id, value) => {
        if (value instanceof Object) {
            renderErrorMessages(value, errorMessages);
        } else {
            errorMessages.append($('<li />').html(value));
        }
    });

    if (first) {
        $('.calculationMessages').each(function appendErrorMessage() {
            $(this).html(errorMessages.html());
        });

        if ($('.calculationDetails').is(':visible')) {
            $('.calculationDetails').hide();
        }

        $('.reservationTotalPrice').html('?');

        if ($('#ReservationPrivateSingleForm_p_type').length > 0) {
            $('#paymentMethodMessage').hide();
        }
    }
}
